module.exports = __webpack_public_path__ + "static/media/map.e1d2d165.svg";